import React from 'react';
import { Calculate } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

const CalculatedIcon: React.FC<SvgIconProps> = (props) => <Calculate {...props} />;

export default CalculatedIcon;

